/**
 * @generated SignedSource<<b183d7d35c673f640ff68f9b97285516>>
 * @relayHash ce8adf92dd687acc3e8fc6d24ffc654f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/581.0.0-2026-10-13T13:14:19.201Z/SellerReviewsModalQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerReviewsModalQuery$variables = {
  count: number;
  isMobileScrollContainer: boolean;
  orderByHighest: boolean;
  orderByImages: boolean;
  orderByLowest: boolean;
  orderByNewest: boolean;
  page: number;
  reviewRating: number;
  sellerId: string;
};
export type SellerReviewsModalQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsMobileModalContent_viewer" | "SellerReviewsModalContent_viewer">;
  };
};
export type SellerReviewsModalQuery = {
  response: SellerReviewsModalQuery$data;
  variables: SellerReviewsModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMobileScrollContainer"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderByHighest"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderByImages"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderByLowest"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderByNewest"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reviewRating"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sellerId"
},
v9 = [
  {
    "kind": "Variable",
    "name": "count",
    "variableName": "count"
  }
],
v10 = {
  "alias": "feedbackFormPhotoUpload",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "feedbackFormPhotoUpload"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"feedbackFormPhotoUpload\")"
},
v11 = {
  "kind": "Literal",
  "name": "excludeInAppealProcess",
  "value": true
},
v12 = {
  "kind": "Literal",
  "name": "excludePrivateItemReviews",
  "value": true
},
v13 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "count"
},
v14 = {
  "kind": "Variable",
  "name": "sellerId",
  "variableName": "sellerId"
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderFeedbackMultipleQueryMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatedOrderFeedbackType",
      "kind": "LinkedField",
      "name": "aggregatedFeedback",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatedOrderFeedbackQuestionType",
          "kind": "LinkedField",
          "name": "overallExperience",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mean",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfPages",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Item",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": [
    (v18/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contemporaryTrackingString",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    (v19/*:: as any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "thumb"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"thumb\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v18/*:: as any*/),
        (v19/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLinkable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "publicNote",
  "plural": false,
  "selections": [
    (v21/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        }
      ],
      "type": "StandardQuestion",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "freetext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visible",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedDate",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyerFirstName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderFeedbackPhoto",
  "kind": "LinkedField",
  "name": "orderPhotos",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "largePath",
      "storageKey": null
    },
    (v19/*:: as any*/)
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "buyerShippingAddress",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayCountry",
      "storageKey": null
    },
    (v19/*:: as any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "overallExperience",
  "plural": false,
  "selections": [
    (v21/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rating",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v29 = {
  "kind": "Literal",
  "name": "orderByNewest",
  "value": true
},
v30 = {
  "kind": "Literal",
  "name": "page",
  "value": 0
},
v31 = {
  "alias": "reviewsWithPhotos",
  "args": [
    (v11/*:: as any*/),
    (v12/*:: as any*/),
    (v28/*:: as any*/),
    {
      "kind": "Literal",
      "name": "hasVisibleFeedbackImages",
      "value": true
    },
    (v29/*:: as any*/),
    (v30/*:: as any*/),
    (v14/*:: as any*/)
  ],
  "concreteType": "OrderFeedbackMultipleQueryConnection",
  "kind": "LinkedField",
  "name": "orderFeedbackMultiple",
  "plural": false,
  "selections": [
    (v16/*:: as any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": "ratingBreakdownMetadata",
  "args": [
    (v11/*:: as any*/),
    (v12/*:: as any*/),
    (v28/*:: as any*/),
    (v30/*:: as any*/),
    (v14/*:: as any*/)
  ],
  "concreteType": "OrderFeedbackMultipleQueryConnection",
  "kind": "LinkedField",
  "name": "orderFeedbackMultiple",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderFeedbackMultipleQueryMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatedOrderFeedbackType",
          "kind": "LinkedField",
          "name": "aggregatedFeedback",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AggregatedOrderFeedbackQuestionType",
              "kind": "LinkedField",
              "name": "overallExperience",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalReviews",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AggregatedOrderFeedbackStarType",
                  "kind": "LinkedField",
                  "name": "starBreakdown",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stars",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "count",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = [
  (v11/*:: as any*/),
  (v12/*:: as any*/),
  (v13/*:: as any*/),
  {
    "kind": "Literal",
    "name": "orderByHighest",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "orderByImages",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "orderByLowest",
    "value": false
  },
  (v29/*:: as any*/),
  (v14/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SellerReviewsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "isMobileScrollContainer",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v9/*:: as any*/),
                "kind": "FragmentSpread",
                "name": "SellerReviewsModalContent_viewer"
              }
            ]
          },
          {
            "condition": "isMobileScrollContainer",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v9/*:: as any*/),
                "kind": "FragmentSpread",
                "name": "SellerReviewsMobileModalContent_viewer"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*:: as any*/),
      (v1/*:: as any*/),
      (v5/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      (v3/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "SellerReviewsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "isMobileScrollContainer",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": [
                  (v11/*:: as any*/),
                  (v12/*:: as any*/),
                  (v13/*:: as any*/),
                  {
                    "kind": "Variable",
                    "name": "orderByHighest",
                    "variableName": "orderByHighest"
                  },
                  {
                    "kind": "Variable",
                    "name": "orderByImages",
                    "variableName": "orderByImages"
                  },
                  {
                    "kind": "Variable",
                    "name": "orderByLowest",
                    "variableName": "orderByLowest"
                  },
                  {
                    "kind": "Variable",
                    "name": "orderByNewest",
                    "variableName": "orderByNewest"
                  },
                  {
                    "kind": "Variable",
                    "name": "page",
                    "variableName": "page"
                  },
                  {
                    "kind": "Variable",
                    "name": "reviewRating",
                    "variableName": "reviewRating"
                  },
                  (v14/*:: as any*/)
                ],
                "concreteType": "OrderFeedbackMultipleQueryConnection",
                "kind": "LinkedField",
                "name": "orderFeedbackMultiple",
                "plural": false,
                "selections": [
                  (v15/*:: as any*/),
                  (v16/*:: as any*/),
                  (v17/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderFeedbackMultipleQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrderFeedback",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*:: as any*/),
                          (v20/*:: as any*/),
                          (v22/*:: as any*/),
                          (v23/*:: as any*/),
                          (v24/*:: as any*/),
                          (v25/*:: as any*/),
                          (v26/*:: as any*/),
                          (v27/*:: as any*/),
                          (v19/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v31/*:: as any*/),
              (v32/*:: as any*/)
            ]
          },
          {
            "condition": "isMobileScrollContainer",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v10/*:: as any*/),
              {
                "alias": "paginatedFeedback",
                "args": (v33/*:: as any*/),
                "concreteType": "OrderFeedbackMultipleQueryConnection",
                "kind": "LinkedField",
                "name": "orderFeedbackMultiple",
                "plural": false,
                "selections": [
                  (v15/*:: as any*/),
                  (v17/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderFeedbackMultipleQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrderFeedback",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*:: as any*/),
                          (v20/*:: as any*/),
                          (v22/*:: as any*/),
                          (v23/*:: as any*/),
                          (v24/*:: as any*/),
                          (v25/*:: as any*/),
                          (v26/*:: as any*/),
                          (v27/*:: as any*/),
                          (v19/*:: as any*/),
                          (v21/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v16/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "paginatedFeedback",
                "args": (v33/*:: as any*/),
                "filters": [
                  "sellerId",
                  "excludeInAppealProcess",
                  "orderByNewest",
                  "orderByHighest",
                  "orderByLowest",
                  "orderByImages",
                  "reviewRating",
                  "excludePrivateItemReviews"
                ],
                "handle": "connection",
                "key": "SellerReviewsMobileModalContent_paginatedFeedback",
                "kind": "LinkedHandle",
                "name": "orderFeedbackMultiple"
              },
              (v31/*:: as any*/),
              (v32/*:: as any*/)
            ]
          },
          (v19/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/581.0.0-2026-10-13T13:14:19.201Z/SellerReviewsModalQuery",
    "metadata": {},
    "name": "SellerReviewsModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fb65ae0d92de613e6f024ee5b4c9815e";

export default node;
